/**
 * User Actions
 *
 * Action creators for User based actions.
 */

// Dependencies
// import { get } from "lodash";

// Action Types
import actionTypes from '../actionTypes';

/**
 * Set the User Object
 *
 * Attempt to set the user object with data about the user.
 *
 * @param {Object} user The user object returned from FusionAuth /api/login.
 */
const setUser = (user) => (dispatch, getState) => {
	// Grab only the pertinent information to send to storage. We don't want everything.
	const savedUser = {
		email: user.email,
		username: user.username,
		firstName: user.firstName,
		lastName: user.lastName,
		id: user.id,
	};

	// Make sure the user supplied to the function is not null / empty.
	if (!user) {
		// Get the language data.
		// const languageData = getState("language").language.languageData;
		// Return with an error message for a toast event.
		// return Toasty.notify({
		//   toastType: Toasty.error(),
		//   toastMessage: get(languageData, ["common", "auth", "noUser"])
		// });
	}

	// Dispatch the result.
	dispatch({
		type: actionTypes.SET_USER,
		payload: {
			info: savedUser,
		},
	});
};

/**
 * Logout User
 *
 * Logs out the user by using the LOGOUT_USER action type. This will
 * set the user.info object to null.
 */
const logoutUser = () => (dispatch, getState) => {
	// Dispatch the result.
	dispatch({
		type: actionTypes.LOGOUT_USER,
	});
	dispatch({
		type: actionTypes.CLEAR_BRAINS,
	});
	dispatch({
		type: actionTypes.CLEAR_TABS,
	});
	dispatch({
		type: actionTypes.CLEAR_DEVICES,
	});
	dispatch({
		type: actionTypes.CLEAR_PROFILES,
	});
};

/**
 * Set User status
 *
 * Logs out the user by using the LOGOUT_USER action type. This will
 * set the user.info object to null.
 */
const setStatus = (status) => (dispatch, getState) => {
	// Dispatch the result.
	// offline if desktop app is user skips signing in
	// online if the user does log in
	dispatch({
		type: actionTypes.SET_STATUS,
		payload: status,
	});
};

// Export the actions.
export { setUser, logoutUser, setStatus };
